import { FC, ReactNode } from "react";

type Props = {
  children: ReactNode;
  bottom?: ReactNode;
};

export const MobileBaseLayout: FC<Props> = ({ children, bottom }) => {
  return (
    <div className="flex flex-col justify-between h-screen w-screen">
      <div className="flex flex-col px-4 gap-4">{children}</div>

      {bottom && (
        <div className="flex flex-col gap-4 p-4 bg-white w-full !z-[25]">
          {bottom}
        </div>
      )}
    </div>
  );
};
